import { Link, createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { useT } from '@/shared/i18n'
import { z } from 'zod'
import { ResetPasswordForm, fetchSession, safeRedirectTarget } from '@/shared/auth'
import { AuthLayout } from '@/widgets/layouts/auth-layout'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

/** UI prototype: no password is changed; "Confirm" returns to the sign-in page (Q31). */
export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, search }) => {
    const { queryClient, auth } = context.services
    const session = await fetchSession(queryClient, auth)
    if (session) throw redirect({ href: safeRedirectTarget(search.redirect) })
  },
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  const t = useT()
  const router = useRouter()
  const search = Route.useSearch()

  return (
    <AuthLayout title={t('auth.reset.changeTitle')}>
      <div className="flex flex-col gap-5">
        <ResetPasswordForm
          onSubmitted={() => {
            void router.navigate({ to: '/login', search: { redirect: search.redirect } })
          }}
        />
        <Link
          to="/login"
          search={{ redirect: search.redirect }}
          className="self-center rounded-sm text-base underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {t('auth.reset.back')}
        </Link>
      </div>
    </AuthLayout>
  )
}
